import React from "react";

export const KpiCard = ({
  label,
  value,
  subLabel,
  icon: Icon,
  onClick,
  isRetailerMobile = false, // 👈 pass this from parent
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        rounded-2xl p-3 flex flex-col justify-between
        transition-all duration-300 cursor-pointer
        ${
          isRetailerMobile
            ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)] active:scale-[0.98]"
            : "bg-white/90 border border-slate-100/80 shadow-lg hover:shadow-md"
        }
      `}
    >
      {/* Top Row */}
      <div className="flex items-center justify-between gap-1">
        <div
          className={`text-xs font-semibold uppercase tracking-wide ${
            isRetailerMobile ? "text-black/80" : "text-slate-500"
          }`}
        >
          {label}
        </div>

        {Icon && (
          <div
            className={`
              p-1.5 rounded-xl border transition-all
              ${
                isRetailerMobile
                  ? "bg-white/20 text-black border-white/30"
                  : "bg-blue-50 text-blue-600 border-blue-100"
              }
            `}
          >
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>

      {/* Value */}
      <div
        className={`mt-2 text-sm lg:text-xl font-bold ${
          isRetailerMobile ? "text-blue-700" : "text-blue-700"
        }`}
      >
        {value}
      </div>

      {/* Sub Label */}
      {subLabel && (
        <div
          className={`mt-1 text-xs truncate ${
            isRetailerMobile ? "text-black/70" : "text-slate-500"
          }`}
        >
          {subLabel}
        </div>
      )}
    </div>
  );
};


// import react from "react";
// export const KpiCard = ({ label, value, subLabel, icon: Icon, onClick  }) => (
//   <div onClick={onClick} className="bg-white/90 rounded-2xl shadow-lg hover:shadow-md transition-shadow p-3 flex flex-col justify-between border border-slate-100/80">
//     <div className="flex items-center justify-between gap-1">
//       <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
//         {label}
//       </div>
//       {Icon && (
//         <div className="p-1 rounded-xl bg-blue-50 text-blue-600 border border-blue-100">
//           <Icon className="w-4 h-4" />
//         </div>
//       )}
//     </div>
//     <div className="mt-2 text-sm lg:text-xl font-bold text-blue-700">{value}</div>
//     {subLabel && (
//       <div className="mt-1 text-xs text-slate-500 truncate">{subLabel}</div>
//     )}
//   </div>
// );